import { get } from "http";
import { SAGA_ACTIONS } from "../../../_config";
import { useApiCall } from "../appApiCallHook";



export function useDataSourceApi() {
  const callApi = useApiCall();

  const addExternalDataSource = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DATASOURCE.ADD_EXTERNAL_DATASOURCE, data, onSuccess, onError);
  };

  const addInternalDataSource = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DATASOURCE.ADD_INTERNAL_DATASOURCE, data, onSuccess, onError);
  };
  
  const getDataSource = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DATASOURCE.GET_DATASOURCES, data, onSuccess, onError);
 }

 

  return {
    addExternalDataSource,
    addInternalDataSource,
    getDataSource,
  };
}
